import gql from "graphql-tag";

const TAG_TRACKING_UPDATE_EVENTS_TARGET = gql`
  mutation updateOrgEventsTarget(
    $orgId: ID
    $cart: String
    $name: String
    $tagUpdateDate: String
    $tagId: ID
    $test: Boolean
    $tag: Json
    $isAmplifyDefault: Boolean
    $appId: String!
    $eventId: ID
    $description: String
  ) {
    updateOrg(
      where: { id: $orgId }
      data: {
        eventsTarget: {
          update: {
            where: { id: $eventId }
            data: {
              name: $name
              description: $description
              test: $test
              cart: $cart
              tag: $tag
              isAmplifyDefault: $isAmplifyDefault
              tagUpdateDate: $tagUpdateDate
              eventTags: {
                update: {
                  where: { id: $tagId }
                  data: { appId: { set: [$appId] } }
                }
              }
            }
          }
        }
      }
    ) {
      id
      name
      eventsTarget {
        id
        name
        description
        pageViews
        signups
        transactions
        retailId
        cart
        test
        tag
        isAmplifyDefault
        segmentId
        segmentName
        tagUpdateDate
        uniqueDevices
        isProcess
        eventTags {
          id
          appId
        }
      }
    }
  }
`;

export default TAG_TRACKING_UPDATE_EVENTS_TARGET;
